import type { Allowance as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Allowance = {
  enabled: boolean;
  key: string;
  label: string;
};

export const fromGql = (item: GQLItem): Allowance =>
  take(item, 'enabled', 'key', 'label') as Allowance;
